module.exports = __webpack_public_path__ + "img/NameTheBand.ebcefa39.svg";